
export default "/assets/inbox-micro.51d452d9.svg"